











































































































import { DetailItem } from "@/store/call/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import BaseItemsPage from "../BaseItemsPage";
import CallDetailFilter from "@/components/Call/Statistic/CallDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";
import { ScrollButton } from "wings-ui-components";
import { colorClassByStatus } from "@/utils/page-utils";

@Component({
  components: {CallDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CallDetail extends BaseItemsPage<DetailItem> {

  @Getter("callStatisticDetail") responseItems: any;
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter = true;
  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'create_date', 'originator', 'recipient', 'partner',
      'service_provider', 'content', 'status',
    ];
  }

  getData() {
    return this.responseItems;
  }
}
